import type {CssValue} from '../../constants'

const serialize = (val: any): CssValue => JSON.stringify(val)
const deserialize = (rule: CssValue): any => {
    try {
        return JSON.parse(rule)
    } catch {
        return rule
    }
}

export default {
    serialize,
    deserialize
}
